const breakpoints = {
  mobile: 320,
  tablet: 768,
  desktop: 1024,
};

export const setBreakpoint = () => {
  /* eslint-disable no-nested-ternary */
  document.body.dataset.breakpoint = window.innerWidth >= breakpoints.desktop ? 'desktop'
    : (window.innerWidth < breakpoints.desktop && window.innerWidth >= breakpoints.tablet) ? 'tablet' : 'mobile';
};

window.addEventListener('resize', setBreakpoint);

export default breakpoints;
